
      var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoSmartMeter = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 120,
  width: 120,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 120 120"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M60 5q6.61.01 12.38 4.51a1.34 1.29 14.5 0 1 .48.79q.21 1.16-.1 1.71a2 1.98 33.5 0 1-2.94.58q-4.72-3.6-9.83-3.61-5.11 0-9.83 3.59a2 1.98-33.5 0 1-2.94-.58q-.31-.55-.1-1.71a1.34 1.29-14.4 0 1 .49-.79Q53.38 5 60 5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M60 12q3.94 0 7.35 2.51a1.4 1.4 0 0 1 .52.79q.16.69.03 1.28a2.04 1.89 24.3 0 1-3.09 1.04q-2.37-1.64-4.82-1.64-2.44 0-4.82 1.63a2.04 1.89-24.1 0 1-3.08-1.05q-.13-.59.03-1.28a1.4 1.4 0 0 1 .52-.79Q56.06 11.99 60 12"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "var(--theme-primary, #810ea9)",
  cx: 60,
  cy: 21.01,
  r: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M60 27q17.58 0 20.93.09 3.92.11 5.46 4.73a2.3 2.25-54.6 0 1 .11.7v57.17a3.27 3.13-38.6 0 1-.11.83q-1.48 5.44-7.82 4.78a.52.51 3 0 0-.57.51v8.73a1.18 1.17-71.8 0 0 .47.94c4.53 3.42 1.35 9.94-4.02 8.24-3.93-1.24-3.92-5.91-.9-8.25a1.17 1.17 0 0 0 .45-.92v-8.58a.6.6 0 0 0-.6-.6H62.54a.57.57 0 0 0-.57.56c-.04 1.57-.16 1.94 1.28 3.25 3.15 2.87.71 7.69-3.25 7.69s-6.4-4.82-3.25-7.69c1.44-1.31 1.32-1.68 1.28-3.25a.57.57 0 0 0-.57-.56H46.6a.6.6 0 0 0-.6.6v8.58a1.17 1.17 0 0 0 .45.92c3.02 2.34 3.03 7.01-.9 8.25-5.37 1.7-8.55-4.82-4.02-8.24a1.18 1.17 71.8 0 0 .47-.94v-8.73a.52.51-3 0 0-.57-.51q-6.34.66-7.82-4.78a3.27 3.13 38.6 0 1-.11-.83V32.52a2.3 2.25 54.6 0 1 .11-.7q1.54-4.62 5.46-4.73Q42.42 27 60 27m22.5 6.09A2.09 2.09 0 0 0 80.41 31H39.59a2.09 2.09 0 0 0-2.09 2.09v56.2a2.09 2.09 0 0 0 2.09 2.09h40.82a2.09 2.09 0 0 0 2.09-2.09zm-21.83 68.94a.75.74-36.5 0 0-.91-.13q-.33.18-.29.44a.63.54-36.9 0 0 1.11.07q.17-.3.09-.38m-17.07 7.78q.43-.01.89-.29a.38.38 0 0 0-.12-.7q-.48-.08-.99.29a.39.38-63.1 0 0 .22.7m32 0q.43-.01.89-.29a.39.37-55.7 0 0-.12-.7q-.48-.08-.99.29a.39.38-63.2 0 0 .22.7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M79.26 47.26a4.1 4.1 0 0 1-4.1 4.1h-30.3a4.1 4.1 0 0 1-4.1-4.1v-9.3a4.1 4.1 0 0 1 4.1-4.1h30.3a4.1 4.1 0 0 1 4.1 4.1zm-4.01-8.98a.4.4 0 0 0-.4-.4h-29.7a.4.4 0 0 0-.4.4v8.7a.4.4 0 0 0 .4.4h29.7a.4.4 0 0 0 .4-.4z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M57.71 76.21 69.06 64.5a2.56 2.56 0 0 1 3.69.02l.14.15a2.73 2.72-45.7 0 1 .04 3.89Q62.57 79 59 82.7c-1.44 1.49-3.07.47-4.35-.83q-5.73-5.84-7.59-7.73a2.68 2.68 0 0 1 .12-3.86l.18-.18a2.42 2.41-44.9 0 1 3.45 0l5.98 6.11a.64.64 0 0 0 .92 0"
})));

      const __svgRaw = "<svg height=\"120\" width=\"120\" xmlns=\"http://www.w3.org/2000/svg\" \r\nviewBox=\"0 0 120 120\" ><path fill=\"var(--theme-primary, #810ea9)\" d=\"M60 5q6.61.01 12.38 4.51a1.34 1.29 14.5 0 1 .48.79q.21 1.16-.1 1.71a2 1.98 33.5 0 1-2.94.58q-4.72-3.6-9.83-3.61-5.11 0-9.83 3.59a2 1.98-33.5 0 1-2.94-.58q-.31-.55-.1-1.71a1.34 1.29-14.4 0 1 .49-.79Q53.38 5 60 5\"/><path fill=\"var(--theme-primary, #810ea9)\" d=\"M60 12q3.94 0 7.35 2.51a1.4 1.4 0 0 1 .52.79q.16.69.03 1.28a2.04 1.89 24.3 0 1-3.09 1.04q-2.37-1.64-4.82-1.64-2.44 0-4.82 1.63a2.04 1.89-24.1 0 1-3.08-1.05q-.13-.59.03-1.28a1.4 1.4 0 0 1 .52-.79Q56.06 11.99 60 12\"/><circle fill=\"var(--theme-primary, #810ea9)\" cx=\"60\" cy=\"21.01\" r=\"2\"/><path d=\"M60 27q17.58 0 20.93.09 3.92.11 5.46 4.73a2.3 2.25-54.6 0 1 .11.7v57.17a3.27 3.13-38.6 0 1-.11.83q-1.48 5.44-7.82 4.78a.52.51 3 0 0-.57.51v8.73a1.18 1.17-71.8 0 0 .47.94c4.53 3.42 1.35 9.94-4.02 8.24-3.93-1.24-3.92-5.91-.9-8.25a1.17 1.17 0 0 0 .45-.92v-8.58a.6.6 0 0 0-.6-.6H62.54a.57.57 0 0 0-.57.56c-.04 1.57-.16 1.94 1.28 3.25 3.15 2.87.71 7.69-3.25 7.69s-6.4-4.82-3.25-7.69c1.44-1.31 1.32-1.68 1.28-3.25a.57.57 0 0 0-.57-.56H46.6a.6.6 0 0 0-.6.6v8.58a1.17 1.17 0 0 0 .45.92c3.02 2.34 3.03 7.01-.9 8.25-5.37 1.7-8.55-4.82-4.02-8.24a1.18 1.17 71.8 0 0 .47-.94v-8.73a.52.51-3 0 0-.57-.51q-6.34.66-7.82-4.78a3.27 3.13 38.6 0 1-.11-.83V32.52a2.3 2.25 54.6 0 1 .11-.7q1.54-4.62 5.46-4.73Q42.42 27 60 27m22.5 6.09A2.09 2.09 0 0 0 80.41 31H39.59a2.09 2.09 0 0 0-2.09 2.09v56.2a2.09 2.09 0 0 0 2.09 2.09h40.82a2.09 2.09 0 0 0 2.09-2.09zm-21.83 68.94a.75.74-36.5 0 0-.91-.13q-.33.18-.29.44a.63.54-36.9 0 0 1.11.07q.17-.3.09-.38m-17.07 7.78q.43-.01.89-.29a.38.38 0 0 0-.12-.7q-.48-.08-.99.29a.39.38-63.1 0 0 .22.7m32 0q.43-.01.89-.29a.39.37-55.7 0 0-.12-.7q-.48-.08-.99.29a.39.38-63.2 0 0 .22.7\"/><path d=\"M79.26 47.26a4.1 4.1 0 0 1-4.1 4.1h-30.3a4.1 4.1 0 0 1-4.1-4.1v-9.3a4.1 4.1 0 0 1 4.1-4.1h30.3a4.1 4.1 0 0 1 4.1 4.1zm-4.01-8.98a.4.4 0 0 0-.4-.4h-29.7a.4.4 0 0 0-.4.4v8.7a.4.4 0 0 0 .4.4h29.7a.4.4 0 0 0 .4-.4z\"/><path fill=\"var(--theme-primary, #810ea9)\" d=\"M57.71 76.21 69.06 64.5a2.56 2.56 0 0 1 3.69.02l.14.15a2.73 2.72-45.7 0 1 .04 3.89Q62.57 79 59 82.7c-1.44 1.49-3.07.47-4.35-.83q-5.73-5.84-7.59-7.73a2.68 2.68 0 0 1 .12-3.86l.18-.18a2.42 2.41-44.9 0 1 3.45 0l5.98 6.11a.64.64 0 0 0 .92 0\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/no-smart-meter.087da3339b4b1e885e06287200cc160a.svg"),
        {
          React: SvgNoSmartMeter,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      